import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { setDataLayout } from "../../data/redux/themeSettingSlice";
import ImageWithBasePath from "../imageWithBasePath";
import {
  setMobileSidebar,
  toggleMiniSidebar,
} from "../../data/redux/sidebarSlice";
import { all_routes } from "../../../feature-module/router/all_routes";
import { logout, userLogout } from "../../../core/data/redux/authSlice";
import ProfileAvatar from "../../../components/ProfileAvatar";
import { performSecureLogout } from "../../utils/logoutUtility";
import { isSupportViewer } from "../../../utils/permissionUtils";

const getUserDisplayName = (userObj: any) => {
  if (!userObj) return "User";
  const firstName = userObj.first_name || userObj.details?.firstname || userObj.details?.first_name || userObj.firstname;
  const lastName = userObj.last_name || userObj.details?.lsastname || userObj.details?.last_name || userObj.lastname;

  if (firstName && lastName) {
    return `${firstName} ${lastName}`.trim();
  }
  if (firstName) return firstName;
  if (userObj.username) return userObj.username;
  if (userObj.details?.fullName) return userObj.details.fullName;
  if (userObj.name) return userObj.name;
  if (userObj.email) return userObj.email;
  return "User";
};

const getUserEmpId = (userObj: any) => {
  if (!userObj) return "";
  if (userObj.empId) return String(userObj.empId);
  if (userObj.details?.empId) return String(userObj.details.empId);
  if (userObj.id) return String(userObj.id);
  return "";
};

const isSupportRole = (userRole?: string): boolean => {
  if (typeof isSupportViewer === "function") {
    return isSupportViewer(userRole);
  }
  const rawRole = String(userRole || "").toUpperCase().trim();
  const normalizedRole = rawRole.replace(/[-_ ]/g, "");
  return (
    rawRole === "SUPPORT-VIEWER" ||
    rawRole === "SUPPORT_VIEWER" ||
    normalizedRole === "SUPPORTVIEWER" ||
    normalizedRole === "SUPPORT" ||
    normalizedRole === "VIEWER"
  );
};

const Header = () => {
  const user: any = localStorage.getItem("user");

  const userJson = user && user != 'undefined' ? JSON.parse(user) : {};


  const routes = all_routes;
  const dispatch = useDispatch();
  const dataLayout = useSelector((state: any) => state.themeSetting.dataLayout);
  const employeesState = useSelector((state: any) => state.employeesState || {});
  const reduxEmpData = employeesState?.data?.data;
  const headerEmpImage =
    reduxEmpData?.details?.image ||
    reduxEmpData?.sap_employee_images?.image ||
    reduxEmpData?.image ||
    userJson?.sap_employee_images?.image ||
    userJson?.image ||
    userJson?.details?.image;
  const Location = useLocation();

  const userType: any = userJson?.user_type || userJson?.role;

  const [subOpen, setSubopen] = useState<any>("");
  const [subsidebar, setSubsidebar] = useState("");
  const navigation = useNavigate();
  const toggleSidebar = (title: any) => {
    localStorage.setItem("menuOpened", title);
    if (title === subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };

  const toggleSubsidebar = (subitem: any) => {
    if (subitem === subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };
  const mobileSidebar = useSelector(
    (state: any) => state.sidebarSlice.mobileSidebar
  );

  const toggleMobileSidebar = () => {
    dispatch(setMobileSidebar(!mobileSidebar));
  };

  const handleToggleMiniSidebar = () => {
    if (dataLayout === "mini_layout") {
      dispatch(setDataLayout("default_layout"));
      localStorage.setItem("dataLayout", "default_layout");
    } else {
      dispatch(toggleMiniSidebar());
    }
  };

  const [isFullscreen, setIsFullscreen] = useState(false);
  const toggleFullscreen = () => {
    if (!isFullscreen) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen().catch((err) => { });
        setIsFullscreen(true);
      }
    } else {
      if (document.exitFullscreen) {
        if (document.fullscreenElement) {
          document.exitFullscreen().catch((err) => { });
        }
        setIsFullscreen(false);
      }
    }
  };

  const handleLogout = async () => {
    const redirectPath = userType === "ADMIN" || userType === "SUBADMIN" || isSupportRole(userType)
      ? routes.adminLogin
      : routes.login;
    await performSecureLogout(dispatch, redirectPath);
  };

  return (
    <>
      {/* Header */}
      <div className="header">
        <div className="main-header">
          <div className="header-left">
            <Link to={userType === "ADMIN" || userType === "SUBADMIN" || isSupportRole(userType) ? routes.adminDashboard : routes.employeeDashboard} className="logo">
              <ImageWithBasePath src="assets/img/logo.svg" alt="Logo" />
            </Link>
            <Link to={userType === "ADMIN" || userType === "SUBADMIN" || isSupportRole(userType) ? routes.adminDashboard : routes.employeeDashboard} className="dark-logo">
              <ImageWithBasePath src="assets/img/logo-white.svg" alt="Logo" />
            </Link>
          </div>

          <Link
            id="mobile_btn"
            onClick={toggleMobileSidebar}
            className="mobile_btn"
            to="#sidebar"
          >
            <span className="bar-icon">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </Link>

          <div className="header-user">
            <div className="nav user-menu nav-list">
              <div
                className="me-auto d-flex align-items-center"
                id="header-search"
              >
                <Link
                  id="toggle_btn"
                  to="#"
                  onClick={handleToggleMiniSidebar}
                  className="btn btn-menubar me-1"
                >
                  <i className="ti ti-arrow-bar-to-left"></i>
                </Link>
                {/* <div className="input-group input-group-flat d-inline-flex me-1">
								<span className="input-icon-addon">
									<i className="ti ti-search"></i>
								</span>
								<input type="text" className="form-control" placeholder="Search in HRMS" />
								<span className="input-group-text">
									<kbd>CTRL + / </kbd>
								</span>
							</div>
							<div className="dropdown crm-dropdown">
								<Link to="#" className="btn btn-menubar me-1" data-bs-toggle="dropdown">
									<i className="ti ti-layout-grid"></i>
								</Link>
								<div className="dropdown-menu dropdown-lg dropdown-menu-start">
									<div className="card mb-0 border-0 shadow-none">
										<div className="card-header">
											<h4>CRM</h4>
										</div>
										<div className="card-body pb-1">
											<div className="row">
												<div className="col-sm-6">
													<Link to={routes.contactList} className="d-flex align-items-center justify-content-between p-2 crm-link mb-3">
														<span className="d-flex align-items-center me-3">
															<i className="ti ti-user-shield text-default me-2"></i>Contacts
														</span>
														<i className="ti ti-arrow-right"></i>
													</Link>
													<Link to={routes.dealsGrid} className="d-flex align-items-center justify-content-between p-2 crm-link mb-3">
														<span className="d-flex align-items-center me-3">
															<i className="ti ti-heart-handshake text-default me-2"></i>Deals
														</span>
														<i className="ti ti-arrow-right"></i>
													</Link>
													<Link to={routes.pipeline} className="d-flex align-items-center justify-content-between p-2 crm-link mb-3">
														<span className="d-flex align-items-center me-3">
															<i className="ti ti-timeline-event-text text-default me-2"></i>Pipeline
														</span>
														<i className="ti ti-arrow-right"></i>
													</Link>
												</div>
												<div className="col-sm-6">
													<Link to={routes.companiesGrid} className="d-flex align-items-center justify-content-between p-2 crm-link mb-3">
														<span className="d-flex align-items-center me-3">
															<i className="ti ti-building text-default me-2"></i>Companies
														</span>
														<i className="ti ti-arrow-right"></i>
													</Link>
													<Link to={routes.leadsGrid} className="d-flex align-items-center justify-content-between p-2 crm-link mb-3">
														<span className="d-flex align-items-center me-3">
															<i className="ti ti-user-check text-default me-2"></i>Leads
														</span>
														<i className="ti ti-arrow-right"></i>
													</Link>
													<Link to={routes.activity} className="d-flex align-items-center justify-content-between p-2 crm-link mb-3">
														<span className="d-flex align-items-center me-3">
															<i className="ti ti-activity text-default me-2"></i>Activities
														</span>
														<i className="ti ti-arrow-right"></i>
													</Link>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<Link to={routes.profilesettings} className="btn btn-menubar">
								<i className="ti ti-settings-cog"></i>
							</Link>	 */}
              </div>

              <div className="d-flex align-items-center">
                {/* <div className="dropdown me-1">
								<Link to="#" className="btn btn-menubar" data-bs-toggle="dropdown">
									<i className="ti ti-layout-grid-remove"></i>
								</Link>
								<div className="dropdown-menu dropdown-menu-end">
									<div className="card mb-0 border-0 shadow-none">
										<div className="card-header">
											<h4>Applications</h4>
										</div>
										<div className="card-body">
											<Link to={routes.calendar} className="d-block pb-2">
												<span className="avatar avatar-md bg-transparent-dark me-2"><i className="ti ti-calendar text-gray-9"></i></span>Calendar
											</Link>
											<Link to={routes.todo} className="d-block py-2">
												<span className="avatar avatar-md bg-transparent-dark me-2"><i className="ti ti-subtask text-gray-9"></i></span>To Do
											</Link>
											<Link to={routes.notes} className="d-block py-2">
												<span className="avatar avatar-md bg-transparent-dark me-2"><i className="ti ti-notes text-gray-9"></i></span>Notes
											</Link>
											<Link to={routes.fileManager} className="d-block py-2">
												<span className="avatar avatar-md bg-transparent-dark me-2"><i className="ti ti-folder text-gray-9"></i></span>File Manager
											</Link>
											<Link to={routes.kanbanView} className="d-block py-2">
												<span className="avatar avatar-md bg-transparent-dark me-2"><i className="ti ti-layout-kanban text-gray-9"></i></span>Kanban
											</Link>
											<Link to={routes.invoice} className="d-block py-2 pb-0">
												<span className="avatar avatar-md bg-transparent-dark me-2"><i className="ti ti-file-invoice text-gray-9"></i></span>Invoices
											</Link>
										</div>
									</div>
								</div>
							</div> */}
                {/* <div className="me-1">
								<Link to={routes.chat} className="btn btn-menubar position-relative">
									<i className="ti ti-brand-hipchat"></i>
									<span className="badge bg-info rounded-pill d-flex align-items-center justify-content-center header-badge">5</span>
								</Link>
							</div> */}

                {/* {userType === 'EMPLOYEE' &&
                  <div className="me-1 notification_item">
                    <Link
                      to="#"
                      className="btn btn-menubar position-relative me-1"
                      id="notification_popup"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-bell"></i>
                      <span className="notification-status-dot"></span>
                    </Link>
                    <div className="dropdown-menu dropdown-menu-end notification-dropdown p-4">
                      <div className="d-flex align-items-center justify-content-between border-bottom p-0 pb-3 mb-3">
                        <h4 className="notification-title">Notifications (2)</h4>
                        <div className="d-flex align-items-center">
                          <Link to="#" className="text-primary fs-15 me-3 lh-1">
                            Mark all as read
                          </Link>
                          <div className="dropdown">
                            <Link
                              to="#"
                              className="bg-white dropdown-toggle"
                              data-bs-toggle="dropdown"
                            >
                              <i className="ti ti-calendar-due me-1"></i>Today
                            </Link>
                            <ul className="dropdown-menu mt-2 p-3">
                              <li>
                                <Link to="#" className="dropdown-item rounded-1">
                                  This Week
                                </Link>
                              </li>
                              <li>
                                <Link to="#" className="dropdown-item rounded-1">
                                  Last Week
                                </Link>
                              </li>
                              <li>
                                <Link to="#" className="dropdown-item rounded-1">
                                  Last Month
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="noti-content">
                        <div className="d-flex flex-column">
                          <div className="border-bottom mb-3 pb-3">
                            <Link to="">
                              <div className="d-flex">
                                <span className="avatar avatar-lg me-2 flex-shrink-0">
                                  <ImageWithBasePath
                                    src="assets/img/profiles/avatar-27.jpg"
                                    alt="Profile"
                                  />
                                </span>
                                <div className="flex-grow-1">
                                  <p className="mb-1">
                                    <span className="text-dark fw-semibold">
                                      Shawn
                                    </span>
                                    performance in Math is below the threshold.
                                  </p>
                                  <span>Just Now</span>
                                </div>
                              </div>
                            </Link>
                          </div>
                          <div className="border-bottom mb-3 pb-3">
                            <Link to="" className="pb-0">
                              <div className="d-flex">
                                <span className="avatar avatar-lg me-2 flex-shrink-0">
                                  <ImageWithBasePath
                                    src="assets/img/profiles/avatar-23.jpg"
                                    alt="Profile"
                                  />
                                </span>
                                <div className="flex-grow-1">
                                  <p className="mb-1">
                                    <span className="text-dark fw-semibold">
                                      Sylvia
                                    </span>{" "}
                                    added appointment on 02:00 PM
                                  </p>
                                  <span>10 mins ago</span>
                                  <div className="d-flex justify-content-start align-items-center mt-1">
                                    <span className="btn btn-light btn-sm me-2">
                                      Deny
                                    </span>
                                    <span className="btn btn-primary btn-sm">
                                      Approve
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </Link>
                          </div>
                          <div className="border-bottom mb-3 pb-3">
                            <Link to="">
                              <div className="d-flex">
                                <span className="avatar avatar-lg me-2 flex-shrink-0">
                                  <ImageWithBasePath
                                    src="assets/img/profiles/avatar-25.jpg"
                                    alt="Profile"
                                  />
                                </span>
                                <div className="flex-grow-1">
                                  <p className="mb-1">
                                    New student record{" "}
                                    <span className="text-dark fw-semibold">
                                      {" "}
                                      George
                                    </span>
                                    is created by{" "}
                                    <span className="text-dark fw-semibold">
                                      Teressa
                                    </span>
                                  </p>
                                  <span>2 hrs ago</span>
                                </div>
                              </div>
                            </Link>
                          </div>
                          <div className="border-0 mb-3 pb-0">
                            <Link to="">
                              <div className="d-flex">
                                <span className="avatar avatar-lg me-2 flex-shrink-0">
                                  <ImageWithBasePath
                                    src="assets/img/profiles/avatar-01.jpg"
                                    alt="Profile"
                                  />
                                </span>
                                <div className="flex-grow-1">
                                  <p className="mb-1">
                                    A new teacher record for{" "}
                                    <span className="text-dark fw-semibold">
                                      Elisa
                                    </span>{" "}
                                  </p>
                                  <span>09:45 AM</span>
                                </div>
                              </div>
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex p-0">
                        <Link to="#" className="btn btn-light w-100 me-2">
                          Cancel
                        </Link>
                        <Link
                          to="/notification"
                          className="btn btn-primary w-100"
                        >
                          View All
                        </Link>
                      </div>
                    </div>
                  </div>
                } */}



                <div className="dropdown profile-dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle d-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <ProfileAvatar
                      empName={getUserDisplayName(reduxEmpData || userJson)}
                      empImage={headerEmpImage}
                      empId={getUserEmpId(reduxEmpData || userJson)}
                      size="sm"
                      showName={false}
                      showEmpId={false}
                    />
                  </Link>
                  <div className="dropdown-menu shadow-none">
                    <div className="card mb-0">
                      <div className="card-header">
                        <ProfileAvatar
                          empName={getUserDisplayName(reduxEmpData || userJson)}
                          empImage={headerEmpImage}
                          empId={getUserEmpId(reduxEmpData || userJson)}
                          size="lg"
                          showName={true}
                          showEmpId={true}
                        />
                      </div>
                      <div className="card-body">
                        <Link
                          className="dropdown-item d-inline-flex align-items-center p-0 py-2"
                          to={userType === "ADMIN" || userType === "SUBADMIN" || isSupportRole(userType) ? routes.adminProfile : routes.myprofile}
                        >
                          <i className="ti ti-user-circle me-1"></i>My Profile
                        </Link>
                        <Link
                          className="dropdown-item d-inline-flex align-items-center p-0 py-2"
                          to={routes.changePassword}
                        >
                          <i className="ti ti-user-circle me-1"></i>Change
                          Password
                        </Link>
                        <button
                          onClick={handleLogout}
                          className="dropdown-item d-inline-flex align-items-center p-0 py-2"
                        >
                          <i className="ti ti-login me-2" /> Logout
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="dropdown mobile-user-menu">
            <Link
              to="#"
              className="nav-link dropdown-toggle d-flex align-items-center justify-content-end"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style={{ height: "50px", padding: "0 10px" }}
            >
              <ProfileAvatar
                empName={getUserDisplayName(userJson)}
                empImage={userJson?.sap_employee_images?.image || userJson?.image}
                empId={getUserEmpId(userJson)}
                size="sm"
                showName={false}
                showEmpId={false}
              />
            </Link>
            <div className="dropdown-menu dropdown-menu-end shadow-none">
              <div className="card mb-0">
                <div className="card-header">
                  <ProfileAvatar
                    empName={getUserDisplayName(userJson)}
                    empImage={userJson?.sap_employee_images?.image || userJson?.image}
                    empId={getUserEmpId(userJson)}
                    size="lg"
                    showName={true}
                    showEmpId={true}
                  />
                </div>
                <div className="card-body">
                  <Link
                    className="dropdown-item d-inline-flex align-items-center p-0 py-2"
                    to={userType === "ADMIN" || userType === "SUBADMIN" || isSupportRole(userType) ? routes.adminProfile : routes.myprofile}
                  >
                    <i className="ti ti-user-circle me-1"></i>My Profile
                  </Link>
                  <Link
                    className="dropdown-item d-inline-flex align-items-center p-0 py-2"
                    to={routes.changePassword}
                  >
                    <i className="ti ti-user-circle me-1"></i>Change Password
                  </Link>
                  <button
                    onClick={handleLogout}
                    className="dropdown-item d-inline-flex align-items-center p-0 py-2 w-100 text-start border-0 bg-transparent"
                  >
                    <i className="ti ti-login me-2" /> Logout
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Header */}
    </>
  );
};

export default Header;
